<template>
  <div class="must-invoice-three">
    <div class="title">
      发票要素
    </div>
    <div class="content">
      <div class="left">
        <div class="top">发票代码</div>
        <div class="bottom">{{item.invoiceCode}}</div>
      </div>
      <div class="center">
        <div class="top">发票号码</div>
        <div class="bottom">{{item.invoiceNo}}</div>
      </div>
      <div class="right">
        <div class="top">发票所在地</div>
        <div class="bottom">{{'--'}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {}
  }
}
</script>
<style scoped lang='less'>
  .must-invoice-three{
    width: 702px;
    height: 208px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 24px;
    .title{
      font-size: 24px;
      color: #9EA9B9;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      padding-bottom: 16px;
      border-bottom: 1px solid #ECEEF1;
    }
    .content{
      display: flex;
      justify-content: space-between;
      padding-top: 28px;
      .right{
        text-align: right;
      }
      .top{
        color: #9EA9B9;
        font-size: 24px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      }
      .bottom{
        color: #3E4966;
        font-size: 28px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      }
    }
  }
</style>
